/**
 * Created by Zyy.
 * User: zouyingyang@qq.com
 * Date: 2021/08/11
 * Time: 11:23
 * 转换数据结构，处理数据
 */

class HandlerData {
  /**
   * 将扁平的一维数组数据转为树形结构
   * @param data 数组对象
   * @param id
   * @param pid
   */
  toTree (data, id, pid, all, sort) {
    const sortTree = (data = []) => {
      return data.sort((a, b) => {
        return a.sort - b.sort
      })
    }
    let list = (data && Array.isArray(data)) ? data : []
    sort && (list = sortTree(list))
    const treeList = list.slice(0)
    const formartFun = (ys, json, sort1) => {
      let len = json.length
      while (len > 0) {
        len--
        let oo = json[len]
        if (ys[id] === oo[pid]) {
          (!ys.children || !Array.isArray(ys.children)) && (ys.children = [])
          ys.children.push(oo)
          sort1 && (ys.children = sortTree(ys.children))
          json.splice(len, 1)
        }
      }
    }
    for (let item of list) {
      formartFun(item, treeList, true)
    }
    if (all) {
      return treeList
    }
    return treeList[0] ? treeList[0].children || [] : []
  }
}
export default HandlerData



// WEBPACK FOOTER //
// ./src/util/handler-data.js